export const useSubscriptionModalOpenState = () => useState<boolean>('isSubscribeModalOpen', () => false)

export const useFilesForSigning = () => useState<File[] | undefined>('filesForSigning')
